import styled, { css } from 'styled-components';

export const FaqsOuter = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  margin: 40px 0 20px;
  @media (min-width: 768px) {
    margin: 40px 0;
  }
  ${(props) =>
    props.hideHeading
      ? css`
          margin: 0;
          @media (min-width: 768px) {
            margin: 0;
          }
        `
      : null}
`;

export const TabsItemCategory = styled.div`
  width: 100%;
  color: white;
  overflow: hidden;
  border-right: none;
  border-bottom: 1px solid #00000018;

  label {
    display: flex;
    color: #000;
    font-weight: 500;
    position: relative;
    font-size: clamp(14px, 2vw, 15px);
    align-items: center;
    justify-content: space-between;
    padding: 10px 1%;
    @media (max-width: 720px) {
      justify-content: space-between;
      cursor: default;
      align-items: center;
      padding: 16px 5%;
    }

    &::after {
      content: '+';
      width: 40px;
      text-align: center;
      transition: all 0.35s;
      font-size: 25px;
      font-weight: 500;
      color: #000000a8;
    }
  }
  .question_name {
    flex-basis: 90%;
  }
  .tab-content {
    max-height: 0;
    padding: 0 5%;
    color: black;
    transition: all 0.35s linear;
    display: ${(props) => (props.resultPage ? 'block' : 'flex')};
    font-size: clamp(14px, 2vw, 15px);
    justify-content: flex-start;
    @media (min-width: 768px) {
      padding: 0 20px;
    }
    a {
      color: #0000ff;
    }
  }
  .flex {
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 4px 0;
    .featureImg {
      width: 30px;
      height: 30px;
    }
    span {
      width: 4px;
      height: 4px;
      display: block;
      background-color: rgba(0, 0, 0, 0.9);
      border-radius: 50%;
    }
  }
`;

export const InputFieldCategory = styled.input`
  position: absolute;
  opacity: 0;
  z-index: -1;

  &:checked {
    + .tabsItem {
      position: relative;
      &:before {
        content: '';
        display: block;
        width: 4px;
        height: 100%;
        background: #ef4e5e;
        position: absolute;
        transition: all 0.35s;
        inset: 0;
        z-index: 2;
      }
      .tab-label {
        &::after {
          content: '-';
          font-size: 25px;
          font-weight: 500;
          width: 40px;
          text-align: center;
          transition: all 0.35s;
          color: #000000a8;
        }
      }
      .tab-content {
        max-height: 100vh;
        padding-bottom: 8px;
      }
    }
  }
`;
